export type ToastKind = 'info' | 'success' | 'error';

export interface Toast {
  id: number;
  message: string;
  kind: ToastKind;
  durationMs: number;
}

type Listener = (t: Toast) => void;

class ToastBus {
  private listeners = new Set<Listener>();
  private counter = 0;

  on(l: Listener): void {
    this.listeners.add(l);
  }
  off(l: Listener): void {
    this.listeners.delete(l);
  }
  push(message: string, kind: ToastKind = 'info', durationMs = 3500): void {
    const t: Toast = { id: ++this.counter, message, kind, durationMs };
    for (const l of this.listeners) l(t);
  }
}

export const toastBus = new ToastBus();

export const toast = {
  info: (m: string): void => toastBus.push(m, 'info'),
  success: (m: string): void => toastBus.push(m, 'success'),
  error: (m: string): void => toastBus.push(m, 'error', 5000),
};
